function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", {
  id: "parliamentTitle"
}, "parliament");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M0 181L181 181 181 0 0 0z",
  transform: "translate(-542 -1246) translate(542 1246)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#373150",
  d: "M125.831 153H52.169c-3.96 0-7.169-3.134-7.169-7s3.21-7 7.169-7h73.662c3.96 0 7.169 3.134 7.169 7s-3.21 7-7.169 7",
  transform: "translate(-542 -1246) translate(542 1246)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EBEAED",
  d: "M56 141L104 141 104 107 56 107z",
  transform: "translate(-542 -1246) translate(542 1246)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#373150",
  d: "M56 108L104 108 104 97 56 97z",
  transform: "translate(-542 -1246) translate(542 1246)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D7D6DC",
  d: "M55 147L77 147 77 78 55 78z",
  transform: "translate(-542 -1246) translate(542 1246)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#373150",
  d: "M55 77L77 77 77 73 55 73zM66 86c-1.657 0-3 1.239-3 2.766V125h6V88.766C69 87.24 67.657 86 66 86",
  transform: "translate(-542 -1246) translate(542 1246)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C3C1CA",
  d: "M55 86L59 86 59 67 55 67z",
  transform: "translate(-542 -1246) translate(542 1246)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#373150",
  d: "M55 67L59 67 57 61z",
  transform: "translate(-542 -1246) translate(542 1246)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C3C1CA",
  d: "M73 86L77 86 77 67 73 67z",
  transform: "translate(-542 -1246) translate(542 1246)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#373150",
  d: "M73 67L77 67 75 61zM110 38L120 38 115 25z",
  transform: "translate(-542 -1246) translate(542 1246)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D7D6DC",
  d: "M104 147L125 147 125 78 104 78zM104 59L125 59 125 52 104 52zM110 45L120 45 120 38 110 38z",
  transform: "translate(-542 -1246) translate(542 1246)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C3C1CA",
  d: "M103 77L126 77 126 59 103 59z",
  transform: "translate(-542 -1246) translate(542 1246)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#373150",
  d: "M119.76 44L114.5 44 109.24 44 104 52 117.568 52 125 52z",
  transform: "translate(-542 -1246) translate(542 1246)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EDEBEA",
  d: "M121 68c0 3.314-2.686 6-6 6s-6-2.686-6-6 2.686-6 6-6 6 2.686 6 6",
  transform: "translate(-542 -1246) translate(542 1246)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C3C1CA",
  d: "M103 124L126 124 126 113 103 113z",
  transform: "translate(-542 -1246) translate(542 1246)"
}))));

var SvgStartOfDayImage = function SvgStartOfDayImage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 181,
    viewBox: "0 0 181 181",
    "aria-labelledby": "parliamentTitle",
    role: "img",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", {
    id: "parliamentTitle"
  }, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStartOfDayImage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/start-of-day-image.ae01b428.svg";
export { ForwardRef as ReactComponent };